import { render, staticRenderFns } from "./CProgress.vue?vue&type=template&id=495a7890&scoped=true&"
import script from "./CProgress.vue?vue&type=script&lang=js&"
export * from "./CProgress.vue?vue&type=script&lang=js&"
import style0 from "./CProgress.vue?vue&type=style&index=0&id=495a7890&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495a7890",
  null
  
)

export default component.exports